import { Select, SelectOption } from '@src/components/Select';
import React from 'react';
import { LocalizedStrings } from '@src/utils/localizedStrings';
import { ApiTypes } from 'common';

type SortOrder = ApiTypes.SortOrder;
const sortOrders = ApiTypes.sortOrders;

interface Props {
  value: SortOrder
  onChange: (v: SortOrder) => void
}

export function SortOrderSelect({ value, onChange }: Props) {
  const options: SelectOption<SortOrder>[] = sortOrders.map((sortOrder) => ({
    value: sortOrder,
    text: lang[sortOrder],
  }));

  return (
    <Select
      options={options}
      onChange={onChange}
      value={value}
      variant="adalong"
    />
  );
}

const lang = LocalizedStrings({
  en: {
    'name-asc': 'A -> Z',
    'name-desc': 'Z -> A',
    'relevance-desc': 'Relevance',
    'mediaCount-asc': 'Less media first',
    'mediaCount-desc': 'More media first',
  },
});
